// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { MDParameter } from './MDParameter';
import { EnumHTTPParameterSource } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumHTTPParameterSource';
import { BEBusinessLogic } from './BEBusinessLogic';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 商业逻辑参数 实体类
 * 商业逻辑参数
 */
export class BLParameter extends MDParameter {
  /** 是否可空 : 是否可空 */
  private _isNullable: boolean;

  /** 设置：是否可空 */
  public get isNullable() {
    return this._isNullable;
  }

  /** 获取：是否可空 */
  public set isNullable(value: boolean) {
    this._isNullable = value;
  }

  /** 参数服务来源 : 暴露为服务时，Http协议的参数来源 */
  private _httpParameterSource: EnumHTTPParameterSource;

  /** 设置：参数服务来源 */
  public get httpParameterSource() {
    return this._httpParameterSource;
  }

  /** 获取：参数服务来源 */
  public set httpParameterSource(value: EnumHTTPParameterSource) {
    this._httpParameterSource = value;
  }

  /** 商业逻辑 的ID */
  private _businessLogic_ID: string;

  /** 获取：商业逻辑 的ID */
  public get businessLogic_ID() {
    return this._businessLogic_ID;
  }

  /** 设置：商业逻辑 的ID */
  public set businessLogic_ID(value: string) {
    this._businessLogic_ID = value;
  }

  /** 商业逻辑  */
  private _businessLogic: BEBusinessLogic;

  /** 获取：商业逻辑  */
  public get businessLogic() {
    return this._businessLogic;
  }

  /** 设置：商业逻辑  */
  public set businessLogic(value: BEBusinessLogic) {
    this._businessLogic = value;
    if (value !== null) {
      this.businessLogic_ID = value.id;
    } else {
      this.businessLogic_ID = '';
    }
  }

  constructor() {
    super();
    this._isNullable = false;
    this._httpParameterSource = EnumHTTPParameterSource.Query;
    this._businessLogic_ID = '';
    this._businessLogic = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BLParameter, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isNullable = element.isNullable;
      this.httpParameterSource = element.httpParameterSource;
      this.businessLogic_ID = element.businessLogic_ID;
      if (hasReference && element.businessLogic !== null) {
        this.businessLogic = element.businessLogic;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isNullable = json.IsNullable;
    this.httpParameterSource = json.HttpParameterSource as EnumHTTPParameterSource;
    this.businessLogic_ID = json.BusinessLogic_ID;
    // if (json.BusinessLogic !== null) {
    //   this.businessLogic = BEBusinessLogic.Create(json.BusinessLogic);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsNullable = this.isNullable;
    json.HttpParameterSource = this.httpParameterSource;
    json.BusinessLogic_ID = this.businessLogic_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('校验属性', 'isNullable', '是否可空', EnumDataType.Bool, this.isNullable, true, '是否可空', '', '');
    context.addRow('服务', 'httpParameterSource', '参数服务来源', EnumDataType.Reference, this.httpParameterSource, true, '暴露为服务时，Http协议的参数来源', 'EnumHTTPParameterSource', 'PGRowEnumValue');
    return context;
  }

  static Create(json: any): BLParameter {
    const bLParameter = new BLParameter();
    bLParameter.Deserialize(json);
    bLParameter.json = json;
    return bLParameter;
  }
}
